import React from 'react';
import { BrainGraph } from '../components/deck/BrainGraph';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, Reveal, Title } from '../components/deck/Type';
const uses = ['Product and AI development', 'Venture-data infrastructure', 'Enterprise security and compliance', 'Institutional sales', 'Customer implementation and success', 'Canadian and US market expansion'];
export function FundraiseSlide() {
  return <Slide index={15} variant="deep" data-id="element-132" data-mp="29ihrnd8tl55s">
      <div className="grid min-h-0 flex-1 grid-cols-[56%_1fr] gap-[3vw]" data-id="element-133" data-mp="25ea5nntqy3b9">
        <div className="flex min-h-0 flex-col" data-id="element-134" data-mp="20o3htq726mu2">
          <Eyebrow data-id="element-135" data-mp="20msdnp9pbd2f">The raise</Eyebrow>
          <Title className="mt-[2.2vh] max-w-[92%]" data-id="element-136" data-mp="20lqoyhzris28">
            Building the intelligence infrastructure for the next generation of
            venture capital.
          </Title>

          <div className="mt-[3.4vh] flex items-baseline gap-[1.4vw]" data-id="element-137" data-mp="2t5pb3pgtl0qq">
            <p className="text-[clamp(38px,4.8vw,102px)] leading-none text-[#F4F7FC]" style={{
            fontFamily: 'var(--font-serif)'
          }} data-id="element-138" data-mp="2ocmnrz2myniz">
              $2M
            </p>
            <span className="text-[clamp(9px,0.94vw,20px)] uppercase tracking-[0.24em] text-[#3B8CFF]" data-id="element-139" data-mp="2tw5jj64ofle4">
              Raising
            </span>
          </div>

          <Reveal delay={0.16} className="mt-auto border-t border-white/12 pt-[2.4vh]" data-id="element-140" data-mp="2k7f9r83eat4k">
            <p className="text-[clamp(18px,2.1vw,44px)] leading-tight text-[#F4F7FC]" style={{
            fontFamily: 'var(--font-serif)'
          }} data-id="element-141" data-mp="267w20gehxjss">
              The Venture Brain Is Awake.
            </p>
            <Caption className="mt-[1.4vh]" data-id="element-142" data-mp="1x7zl50yclp8a">
              StartupFuel is building the intelligence layer. DiligenceGPT™ helps
              investors act on it.
            </Caption>
            <p className="mt-[2vh] text-[clamp(10px,1.05vw,22px)] text-[#C3CBD9]" data-id="element-143" data-mp="3rkpe9ggw6uem">
              Ashley “Ash” Martis · Founder &amp; CEO ·{' '}
              <span className="text-[#3B8CFF]" data-id="element-144" data-mp="3vmaosv5yewln">startupfuel.com</span>
            </p>
          </Reveal>
        </div>

        <div className="relative flex min-h-0 flex-col" data-id="element-145" data-mp="18ca8neijtmhu">
          <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#2FBE8F]" data-id="element-146" data-mp="13e8nmo1kbd3q">
            Use of funds
          </span>
          <ul className="mt-[2.2vh] space-y-[1.4vh]" data-id="element-147" data-mp="zfsx4a69vmlk">
            {uses.map((use, i) => <Reveal key={use} delay={0.06 * i} className="border-b border-white/8 pb-[1.4vh] text-[clamp(10.5px,1.14vw,24px)] text-[#DCE3EE]" data-id="element-148" data-mp="ugonjiffrmup" data-mpi={i}>
                {use}
              </Reveal>)}
          </ul>
          <BrainGraph density={1} className="pointer-events-none absolute -right-[3vw] bottom-[-4vh] h-[22vh] w-auto opacity-40" data-id="element-149" data-mp="1iazshcu09h0q" />
        </div>
      </div>
    </Slide>;
}